window.hqScrollLock = window.hqScrollLock || (function () {
  /* Page scroll lock for full-screen viewers. overflow:hidden alone does not
     stop iOS Safari from scrolling the page under a fixed overlay, so the body
     is pinned with position:fixed at its current offset and put back on
     release. The theme's smooth-scroll engine is paused as well. */
  var y = 0, on = false;
  return {
    lock: function () {
      if (on) return;
      on = true;
      y = window.scrollY || window.pageYOffset || 0;
      var b = document.body.style;
      document.documentElement.style.overflow = 'hidden';
      b.position = 'fixed'; b.top = (-y) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
      if (window.__hqLenis && window.__hqLenis.stop) window.__hqLenis.stop();
    },
    unlock: function () {
      if (!on) return;
      on = false;
      var b = document.body.style;
      document.documentElement.style.overflow = '';
      b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
      var html = document.documentElement, prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      html.style.scrollBehavior = prev;
      if (window.__hqLenis && window.__hqLenis.start) window.__hqLenis.start();
    }
  };
})();
/* assets/hq-pdp-clip-ins.js

   The hq2-pdp component, lifted out of sections/hq-pdp-clip-ins.liquid.

   It was moved because the section file had grown past Shopify's 256 KB
   ceiling and would no longer save. Nothing here was rewritten: the block
   carried no Liquid at all, so it moves across verbatim and the section loads
   it with a deferred <script src>.

   Two things follow from that and are worth knowing.

   It is now cached by the browser instead of being re-sent inside every
   product page's HTML, which takes about 59 KB off each PDP response.

   And it no longer re-executes when the theme editor re-renders the section.
   That changes nothing in practice: the IIFE already returned early on the
   customElements guard, so a second run never did anything, and the element's
   own connectedCallback still fires on the fresh markup.
*/

(() => {
  if (customElements.get('hq2-pdp')) return;

  const money = (cents, fmt) =>
    fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      const n = cents / 100;
      if (k.includes('with_comma_separator')) return n.toLocaleString('de-DE', { minimumFractionDigits: 2 });
      if (k.includes('no_decimals')) return Math.round(n).toLocaleString('en-US');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2 });
    });

  const businessDays = (from, days) => {
    const d = new Date(from);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  };

  /* Shopify's handleize, near enough: lowercased, every run of non-alphanumerics
     collapsed to one dash, no dash left at either end. "B2/18" -> b2-18,
     "HE 6/6/70" -> he-6-6-70, "Champagne Blonde Blend" -> champagne-blonde-blend.

     Replacing the old pair of expressions, which turned separators into dashes
     and then stripped whatever was left over: that left a trailing dash on a
     value ending in punctuation, and a file-name probe carries dashes on both
     sides, so those shades matched nothing. */
  const handleize = (raw) =>
    String(raw).trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  /* Two ways to read a code out of an option value. Which one is in force comes
     from the section setting, through data-shade-mode, so this and the Liquid
     above cannot disagree.

     last-token: "Chestnut Red #34" -> 34, "Rooted Ash Blonde B2/18" -> b2-18.
       The code is whatever trails the value — after the # when there is one,
       otherwise the last word. Only about half the extension shades carry a
       hash; the balayage and piano values do not, and requiring one meant those
       shades produced no code at all and were never filtered.

     full-handle: the value IS the code. Bundle shades are written as names, and
       four of the eight end in "Blend" — under last-token they all read as the
       same code, so the palette showed one tile for six shades and the gallery
       filter matched nothing. */
  const shadeCode = (raw, mode) => {
    const s = String(raw).trim();
    if (mode === 'full-handle') return handleize(s);
    const hash = s.lastIndexOf('#');
    return handleize(hash === -1 ? s.split(/\s+/).pop() : s.slice(hash + 1));
  };

  class HQ2PDP extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-hq2-variants]').textContent);
      this.moneyCfg = JSON.parse(this.querySelector('[data-hq2-money]').textContent);
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-hq2-id]');
      this.qtyInput = this.querySelector('[data-hq2-qty-input]');
      this.atc = this.querySelector('[data-hq2-atc]');
      this.optColor = parseInt(this.dataset.optColor, 10);
      this.optTex = parseInt(this.dataset.optTex, 10);
      this.optLen = parseInt(this.dataset.optLen, 10);

      /* Above 250 variants this.variants is only the first 250 Liquid returned,
         so nothing may be resolved from it — the server does that instead. */
      this.highVariant = this.dataset.highVariant === 'true';

      if (this.highVariant) {
        /* The landing variant can sit past the cut, in which case
           currentVariant() would miss and report variants[0]. The buttons
           Liquid already marked are the reliable record of what is selected. */
        this.selected = [];
        this.querySelectorAll('[data-hq2-value][aria-pressed="true"]').forEach(b => {
          this.selected[parseInt(b.dataset.position, 10) - 1] = b.dataset.value;
        });
      } else {
        this.selected = this.currentVariant()?.options.slice() || [];
      }

      this.bindOptions();
      this.bindFamilies();
      this.bindQty();
      this.bindGallery();
      this.bindForm();
      this.bindUGC();
      this.bindAccordions();
      this.bindZoom();
      this.bindSticky();
      this.renderEta();
      this.render();
    }

    currentVariant() {
      const id = parseInt(this.idInput.value, 10);
      return this.variants.find(v => v.id === id) || this.variants[0];
    }

    matchFor(options) {
      return this.variants.find(v => options.every((o, i) => o == null || v.options[i] === o));
    }

    /* ---- options ---- */
    bindOptions() {
      this.querySelectorAll('[data-hq2-value]').forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.highVariant) { this.selectRemote(btn); return; }

          const pos = parseInt(btn.dataset.position, 10) - 1;
          this.selected[pos] = btn.dataset.value;

          // Resolve to an available variant, relaxing later options first.
          let match = this.variants.find(v =>
            v.options.every((o, i) => o === this.selected[i]) && v.available
          ) || this.variants.find(v => v.options.every((o, i) => o === this.selected[i]));

          if (!match) {
            const partial = this.selected.slice();
            for (let i = partial.length - 1; i > pos; i--) {
              partial[i] = null;
              match = this.variants.find(v =>
                partial.every((o, j) => o == null || v.options[j] === o) && v.available
              ) || this.matchFor(partial);
              if (match) break;
            }
          }
          if (match) { this.idInput.value = match.id; this.selected = match.options.slice(); }
          this.render();
        });
      });
    }

    /* ---- high-variant mode: the server resolves the variant ----
       Each click asks Shopify to render this section for the chosen option
       values. The server holds the whole variant set, so its answer is right
       by construction — no amount of client-side matching against a truncated
       list could be. */
    async selectRemote(btn) {
      const pos = parseInt(btn.dataset.position, 10) - 1;
      this.selected[pos] = btn.dataset.value;
      this.render();                       // pills respond immediately

      const ids = [...this.querySelectorAll('[data-hq2-value][aria-pressed="true"]')]
        .sort((a, b) => a.dataset.position - b.dataset.position)
        .map(b => b.dataset.valueId)
        .filter(Boolean);
      if (!ids.length) return;

      this.remote?.abort();
      this.remote = new AbortController();
      this.classList.add('hq2-busy');

      try {
        const url = `${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`;
        const html = await fetch(url, { signal: this.remote.signal }).then(r => r.text());
        const src = new DOMParser().parseFromString(html, 'text/html').querySelector('hq2-pdp');
        if (src) this.mergeRemote(src);
      } catch (err) {
        if (err.name !== 'AbortError') console.error('[hq2] variant fetch failed', err);
      } finally {
        this.classList.remove('hq2-busy');
      }
    }

    mergeRemote(src) {
      const pair = sel => [src.querySelector(sel), this.querySelector(sel)];

      const [sId, tId] = pair('[data-hq2-id]');
      if (sId && tId) tId.value = sId.value;

      ['[data-hq2-price]', '[data-hq2-compare]', '[data-hq2-save]', '[data-hq2-sale-badge]']
        .forEach(sel => {
          const [s, t] = pair(sel);
          if (!s || !t) return;
          t.textContent = s.textContent.trim();
          t.hidden = s.hidden;
          /* The tier ladder needs the figure in cents, not the formatted
             string. Above the 250-variant cap this response is the only place
             it exists: currentVariant() would miss and answer with
             variants[0], quoting the cheapest shade on every other one. */
          if (s.dataset.cents) t.dataset.cents = s.dataset.cents;
        });

      const [sAtc, tAtc] = pair('[data-hq2-atc]');
      const available = sAtc ? !sAtc.hasAttribute('disabled') : true;
      if (tAtc) tAtc.disabled = !available;

      const [sTxt, tTxt] = pair('[data-hq2-atc-text]');
      if (sTxt && tTxt) tTxt.textContent = sTxt.textContent.trim();

      /* Shop Pay quotes an instalment for one specific variant, so the banner
         has to follow the selection — but by attribute, never by replacing the
         markup. <shopify-payment-terms> is a web component: swapping its HTML
         destroys it, collapsing the row to nothing until it re-renders, and
         every option click made the whole column jump. Setting variant-id
         leaves the element in place and lets it refresh itself. */
      const termsEl = this.querySelector('shopify-payment-terms');
      if (termsEl && tId?.value) termsEl.setAttribute('variant-id', tId.value);

      this.querySelectorAll('[data-hq2-selected-label]').forEach(el => {
        const s = src.querySelector(`[data-hq2-selected-label="${el.dataset.hq2SelectedLabel}"]`);
        if (s) el.textContent = s.textContent.trim();
      });

      /* The stock line and the sticky bar are drawn by this script and never by
         Liquid, so there is nothing in the response to copy — they are derived
         from the availability the response did carry. */
      const stock = this.querySelector('[data-hq2-stock]');
      if (stock) {
        stock.dataset.state = available ? 'ok' : 'out';
        const txt = stock.querySelector('[data-hq2-stock-text]');
        if (txt) txt.textContent = available
          ? 'In stock — ready to ship'
          : 'Out of stock — join the restock list';
      }

      this.syncAtcPrice(available);
      this.syncSticky({ meta: this.selected.filter(Boolean).join(' / ') });
      this.syncTierPrices();

      if (this.dataset.history === 'true' && tId?.value && window.history.replaceState) {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${tId.value}`);
      }
    }

    /* ---- shade family filter ---- */

    /* The pills are rendered by Liquid, so this only fills in the counts and
       wires the clicks. Building them here was the old approach and it failed
       silently whenever a swatch lost its data-family. */
    bindFamilies() {
      const wrap = this.querySelector('[data-hq2-fams]');
      if (!wrap) return;

      this.famBtns = [...wrap.querySelectorAll('[data-hq2-fam]')];
      if (!this.famBtns.length) return;

      const swatches = [...this.querySelectorAll('.hq2-sw')];
      this.famBtns.forEach(b => {
        const key = b.dataset.hq2Fam;
        const n = key === '*'
          ? swatches.length
          : swatches.filter(sw => (sw.dataset.family || '').trim() === key).length;
        const sup = b.querySelector('[data-hq2-fam-count]');
        if (sup) sup.textContent = n;
        /* A family the registry names but this product does not carry would be
           an empty filter, so it is dropped rather than shown at zero. */
        if (key !== '*' && n === 0) b.hidden = true;
      });

      this.famBtns.forEach(b => b.addEventListener('click', () => this.applyFamily(b.dataset.hq2Fam)));
    }

    applyFamily(fam) {
      this.famBtns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.hq2Fam === fam)));
      let shown = 0;
      this.querySelectorAll('.hq2-sw').forEach(sw => {
        const on = fam === '*' || sw.dataset.family === fam;
        sw.hidden = !on;
        if (on) shown++;
      });
      const count = this.querySelector('[data-hq2-shade-count]');
      if (count) count.textContent = `${shown} shade${shown === 1 ? '' : 's'}`;
    }

    renderShade() {
      const box = this.querySelector('[data-hq2-shade-desc]');
      if (!box) return;
      const sel = this.querySelector('.hq2-sw[aria-pressed="true"]');
      const desc = sel?.dataset.desc;
      if (!sel || !desc) { box.hidden = true; return; }
      box.hidden = false;
      this.querySelector('[data-hq2-shade-desc-name]').textContent = `${sel.dataset.label}:`;
      this.querySelector('[data-hq2-shade-desc-body]').textContent = desc;
    }

    /* ---- quantity + tiers ---- */
    bindQty() {
      this.querySelectorAll('[data-hq2-qty]').forEach(b => {
        b.addEventListener('click', () => {
          const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + parseInt(b.dataset.hq2Qty, 10));
          this.qtyInput.value = next;
          this.syncTiers(next);
        });
      });
      this.qtyInput?.addEventListener('change', () => this.syncTiers(parseInt(this.qtyInput.value, 10) || 1));

      this.querySelectorAll('[data-hq2-tier]').forEach(t => {
        t.addEventListener('click', () => {
          const q = parseInt(t.dataset.hq2Tier, 10);
          this.qtyInput.value = q;
          this.syncTiers(q);
          this.render();
        });
      });
      /* The tiers are an accelerator, not a floor.

         This used to assign the FIRST tier's quantity on load. With rows that
         start at two packs, that made two the smallest order anyone could
         place: the field opened at 2, and nothing else in the column offered
         one. A customer who wants a single pack has to notice the minus button
         and work back down — most will not, and some will leave instead.

         The field now keeps the quantity the markup set, and a tier is
         preselected only when the block explicitly asks for it. */
      const preset = this.querySelector('[data-hq2-tier][data-hq2-tier-default]');
      if (preset) this.qtyInput.value = preset.dataset.hq2Tier;
      this.syncTiers(parseInt(this.qtyInput?.value, 10) || 1);
    }

    /* The variant price in cents.

       data-cents is written by Liquid on first render, refreshed by render()
       below the variant cap and copied out of the server response above it, so
       it is the one figure that is right in both modes. The variant object is
       a fallback for a template where the price block has been removed. */
    basePriceCents() {
      const el = this.querySelector('[data-hq2-price]');
      const fromAttr = el ? parseInt(el.dataset.cents, 10) : NaN;
      if (!isNaN(fromAttr)) return fromAttr;
      if (this.highVariant) return null;
      const v = this.currentVariant();
      return v && typeof v.price === 'number' ? v.price : null;
    }

    /* Money for a tier pill, which has about 45px to say it in.

       formatMoney() always prints two decimals, and at this size ".00" is the
       difference between a figure that fits and one that ellipsises. These
       prices are whole dollars almost always - the vendor sheets are - so the
       decimals are dropped when there is nothing behind them and kept when
       there is, which is the same rule money_without_trailing_zeros follows in
       Liquid.

       The prefix and suffix still come off the rendered price, so a converted
       market keeps its own spelling rather than Intl's. */
    formatTierMoney(cents) {
      // if (cents % 100 !== 0) return this.formatMoney(cents);

      const sample = (this.querySelector('[data-hq2-price]')?.textContent || '').trim();
      const firstDigit = sample.search(/\d/);
      const lastDigit = sample.search(/\d(?!.*\d)/);
      const prefix = firstDigit > -1 ? sample.slice(0, firstDigit) : '';
      const suffix = lastDigit > -1 ? sample.slice(lastDigit + 1) : '';

      if (!this._whole) {
        this._whole = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      }
      return prefix + this._whole.format(cents / 100) + suffix;
    }

    /* Per-unit price on every tier pill, recomputed from the selected variant.

       Every pill rather than only the selected one: the point of a ladder is
       that the rungs can be compared without clicking each of them, and the
       extension prices are not one base with a flat uplift the way the bundles
       are - a light shade at 30 inches costs well over twice a dark one at 14,
       so the whole ladder moves with the shade. */
    syncTierPrices() {
      const pills = [...this.querySelectorAll('[data-hq2-tier]')];
      if (!pills.length) return;

      const base = this.basePriceCents();

      pills.forEach((pill) => {
        const priceEl = pill.querySelector('[data-hq2-tier-price]');
        if (!priceEl) return;

        if (base == null) { priceEl.textContent = ''; return; }

        const off = parseFloat(pill.dataset.hq2TierOff) || 0;
        // const unit = Math.round(base * (1 - off / 100));
        /* Round to a whole currency unit (in cents: nearest 100) */
const unit = Math.round(base * (1 - off / 100) / 100) * 100;
        const money = this.formatTierMoney(unit);
        priceEl.textContent = money;

        /* Everything the pill shows as a glyph is aria-hidden, so the spoken
           version is assembled here instead - and it is the only place the
           unit word from the rows still has room to be said out loud. */
        const name = pill.dataset.hq2TierName || '';
        const suffix = pill.dataset.hq2TierSuffix || '';
        const badge = pill.dataset.hq2TierBadge || '';
        let spoken = name;
        spoken += ', ' + money + (suffix ? ' ' + suffix : '');
        if (off > 0) spoken += ', save ' + off + ' percent';
        if (badge) spoken += ', ' + badge;
        pill.setAttribute('aria-label', spoken);
      });

      /* Every path that moves a pill's price moves this line too. */
      this.syncTierSavings();
    }

    syncTiers(q) {
      this.querySelectorAll('[data-hq2-tier]').forEach(t =>
        t.setAttribute('aria-pressed', String(parseInt(t.dataset.hq2Tier, 10) === q))
      );
      /* Both the ladder and the button quote the pressed tier, so both have to
         follow the press. The stepper and the quantity field reach this method
         without going anywhere near render(), which is how the button kept
         quoting a quantity of one while the field said three. */
      this.syncTierPrices();
      this.syncAtcPrice();
    }

    /* ---- gallery ---- */
    bindGallery() {
      this.slides = this.querySelector('[data-hq2-slides]');
      if (!this.slides) return;
      const thumbs = [...this.querySelectorAll('[data-hq2-thumb]')];
      const dots = [...this.querySelectorAll('[data-hq2-dot]')];

      const goTo = i => {
        const slide = this.querySelector(`[data-hq2-slide="${i}"]`);
        if (slide) this.slides.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      };

      thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.hq2Thumb)));
      dots.forEach(d => d.addEventListener('click', () => goTo(d.dataset.hq2Dot)));

      /* Arrows step through what is actually on screen. Stepping by index
         would walk into slides the shade filter has hidden and look broken —
         one tap doing nothing, the next jumping two photos. */
      const step = dir => {
        const vis = [...this.querySelectorAll('[data-hq2-slide]')]
          .filter(s => !s.classList.contains('hq2-off'));
        if (!vis.length) return;
        const mid = this.slides.scrollLeft + this.slides.clientWidth / 2;
        let at = vis.findIndex(s => s.offsetLeft + s.offsetWidth > mid);
        if (at === -1) at = vis.length - 1;
        /* Wrap instead of stopping. Clamping left the arrow on screen, enabled,
           and doing nothing at either end, which reads as broken rather than as
           "that's the last one". The wrap itself is not animated: sliding back
           through every photo to reach the first one takes seconds and looks
           like a malfunction of its own. */
        const target = at + dir;
        const wrapped = target < 0 || target > vis.length - 1;
        const next = vis[(target + vis.length) % vis.length];
        if (next) {
          this.slides.scrollTo({ left: next.offsetLeft, behavior: wrapped ? 'auto' : 'smooth' });
        }
      };
      this.querySelector('[data-hq2-prev]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-hq2-next]')?.addEventListener('click', () => step(1));

      /* The swipe wraps as well, so the gesture and the arrows behave the same.
         Native scrolling has no notion of a loop: it reaches the last photo and
         stops dead, which on a phone feels like the gallery has jammed.

         The gesture is judged from where it started, not from where it ended:
         by the time the finger lifts the browser has already snapped back from
         the rubber-band, so the scroll position no longer says whether the end
         was reached. The jump itself is instantaneous and deferred by one frame
         — the browser is still settling its own snap animation on touchend, and
         a smooth scroll issued into that gets swallowed. */
      let touchX = 0;
      let lastX = 0;
      let fromStart = false;
      let fromEnd = false;

      this.slides.addEventListener(
        'touchstart',
        e => {
          touchX = lastX = e.touches[0].clientX;
          const max = this.slides.scrollWidth - this.slides.clientWidth;
          fromStart = this.slides.scrollLeft <= 2;
          fromEnd = this.slides.scrollLeft >= max - 2;
        },
        { passive: true }
      );

      /* Tracked separately because the finishing event does not always carry a
         position: a swipe that runs past the first photo is often taken over by
         the browser's own edge gesture, which ends the sequence with touchcancel
         and an empty touch list. That is also why both events are listened for —
         with only touchend, swiping backwards from the first photo did nothing
         at all while swiping forwards from the last one worked. */
      this.slides.addEventListener(
        'touchmove',
        e => {
          if (e.touches[0]) lastX = e.touches[0].clientX;
        },
        { passive: true }
      );

      const finishSwipe = e => {
          const endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : lastX;
          const dx = endX - touchX;
          if (Math.abs(dx) < 45) return; /* a tap, or a nudge that snapped back */

          const vis = [...this.querySelectorAll('[data-hq2-slide]')]
            .filter(s => !s.classList.contains('hq2-off'));
          if (vis.length < 2) return;

          let target = null;
          if (dx < 0 && fromEnd) target = vis[0];
          else if (dx > 0 && fromStart) target = vis[vis.length - 1];
          if (!target) return;

          /* Snapping is switched off for the length of the jump. The browser
             runs its own snap animation after the finger lifts, and at the
             ends — where the rubber-band pulls back — that animation finished
             after ours and dragged the gallery straight back to where it
             started. With snapping off the assignment cannot be overruled;
             it goes back on the next frame, once the position is settled. */
          const slides = this.slides;
          requestAnimationFrame(() => {
            const snap = slides.style.scrollSnapType;
            slides.style.scrollSnapType = 'none';
            slides.scrollLeft = target.offsetLeft;
            requestAnimationFrame(() => {
              slides.style.scrollSnapType = snap;
            });
          });
      };

      this.slides.addEventListener('touchend', finishSwipe, { passive: true });
      this.slides.addEventListener('touchcancel', finishSwipe, { passive: true });

      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.intersectionRatio > 0.6) {
            const i = e.target.dataset.hq2Slide;
            thumbs.forEach(t => t.setAttribute('aria-current', String(t.dataset.hq2Thumb === i)));
            dots.forEach(d => d.setAttribute('aria-current', String(d.dataset.hq2Dot === i)));
          }
        });
      }, { root: this.slides, threshold: [0.6] });
      this.querySelectorAll('[data-hq2-slide]').forEach(s => io.observe(s));
      this.goToMedia = goTo;
      this.markSingleSlide();
    }

    /* ---- gallery filtered to the selected shade ---- */

    /* data-shade is stamped by Liquid at render time, so this only compares two
       strings — no file name parsing, nothing that can drift out of sync with
       the markup. Media with an empty data-shade serves every shade. */
    /* One visible photograph needs no way to reach the next one. The count is
       of what is ON SCREEN, not of what the product has: the gallery is
       filtered to the selected shade, so a product with nine photos can be
       showing exactly one of them. Re-checked after every filter pass. */
    markSingleSlide() {
      const shown = [...this.querySelectorAll('[data-hq2-slide]')]
        .filter(s => !s.classList.contains('hq2-off')).length;
      this.dataset.singleSlide = String(shown < 2);
    }

    /* Filter first, then re-count — the arrows and dots follow the result. */
    syncGallery(v) {
      this.filterGallery(v);
      this.markSingleSlide();
    }

    /* Public entry point, called by the bundle builder.

       On bundle listings the variant picker is removed and the builder owns the
       shade, so this section has no [data-hq2-value] buttons to listen to and
       render() runs exactly once, at init. The gallery therefore filtered to
       whichever shade happened to load first and then froze — every later
       choice changed the price and the swatch ring but not a single photograph.

       A method rather than an event: the builder already reaches into this
       element for the sticky bar, and one caller does not justify a listener
       whose failure would be silent in the same way. */
    filterByShade(value) {
      if (!value) return;
      this.pickedShade = value;
      this.applyExternalFilter();
    }

    /* The texture half of the same entry point. The builder owns both choices
       on a bundle listing, and they change independently — a length tap leaves
       the shade alone and a texture tap leaves the shade alone — so each is
       remembered here and the filter is applied from both.

       Kept as its own method rather than one call taking two arguments: the
       caller would then have to pass the value it is NOT changing, and passing
       a stale copy of it is exactly the bug this avoids. */
    filterByTexture(value) {
      if (!value) return;
      this.pickedTexture = value;
      this.applyExternalFilter();
    }

    applyExternalFilter() {
      /* A sparse array: filterGallery reads only the colour and texture slots,
         and building a full option list here would mean guessing at the length
         the builder holds. */
      const options = [];
      const cPos = parseInt(this.dataset.optColor, 10);
      const tPos = parseInt(this.dataset.optTex, 10);
      if (cPos > 0 && this.pickedShade) options[cPos - 1] = this.pickedShade;
      if (tPos > 0 && this.pickedTexture) options[tPos - 1] = this.pickedTexture;
      if (!options.length) return;
      this.syncGallery({ options });
    }

    /* Two axes, one pass.

       A file is stamped with a shade, a texture, both or neither, and an empty
       stamp means "serves every one of them" — a colour chart carries no shade,
       a packaging shot carries neither. So a slide is shown when each stamp it
       DOES carry agrees with what is selected. That one rule covers the
       texture-less bundle listings, where every file is stamped with a shade
       only, and the clip-in sets, where the heroes carry both. */
    filterGallery(v) {
      const cPos = parseInt(this.dataset.optColor, 10);
      const tPos = parseInt(this.dataset.optTex, 10);

      const code = cPos > 0 ? shadeCode(v.options[cPos - 1] || '', this.dataset.shadeMode) : '';
      /* `let`, not `const`: the texture is given up below when nothing was
         photographed in it. */
      let tex = tPos > 0 ? handleize(v.options[tPos - 1] || '') : '';
      if (!code && !tex) return;

      const fits = (el) => {
        const s = el.dataset.shade;
        const t = el.dataset.texture;
        if (s && code && s !== code) return false;
        if (t && tex && t !== tex) return false;
        return true;
      };

      const slides = [...this.querySelectorAll('[data-hq2-slide]')];

      let hasOwn = slides.some(el => (el.dataset.shade || el.dataset.texture) && fits(el));

      /* The texture is relaxed BEFORE the shade is given up.

         A set photographed in one texture only — every file named
         clipin-straight-… while the option offers three — matched nothing at
         all on Body Wave or Curly, and the whole filter fell through to
         showing all two hundred photographs. Wrong shade is worse than wrong
         texture: the colour is what the customer is matching against, the
         texture is a finish of the same hair. So the shade is kept and the
         texture is dropped, and the note under the stage says which texture
         they are actually looking at.

         Self-disabling: once files carrying the missing texture are uploaded,
         the first test passes and none of this runs. Nothing to undo later. */
         let shownTex = '';
        const inTex = !tex || slides.some(el =>
        el.dataset.texture === tex && (!el.dataset.shade || el.dataset.shade === code));
      if (!inTex && code && tex) {
        const byShade = slides.filter(el => el.dataset.shade === code);
        if (byShade.length) {
          shownTex = byShade.find(el => el.dataset.texture)?.dataset.texture || '';
          tex = '';
          hasOwn = true;
        }
      }
      this.noteTexture(shownTex);

      /* A combination with no photographs of its own used to fall back to the
         whole set, which meant picking a balayage showed solid browns and
         blondes — worse than showing less, because it reads as the wrong
         product rather than as a gap. General media (charts, packaging,
         application video) carries no stamp at all and serves every
         combination, so that is what it falls back to now. Only when there is
         no general media either does it show everything, since an empty stage
         would be worse still. */
      if (!hasOwn) {
        const general = slides.filter(el => !el.dataset.shade && !el.dataset.texture);

        if (!general.length) {
          this.querySelectorAll('.hq2-off').forEach(el => el.classList.remove('hq2-off'));
          return;
        }

        let firstGeneral = null;
        this.querySelectorAll('[data-shade]').forEach(el => {
          const on = !el.dataset.shade && !el.dataset.texture;
          el.classList.toggle('hq2-off', !on);
          if (on && !firstGeneral && el.hasAttribute('data-hq2-slide')) firstGeneral = el;
        });
        if (firstGeneral && this.goToMedia) this.goToMedia(firstGeneral.dataset.hq2Slide);
        return;
      }

      let first = null;
      this.querySelectorAll('[data-shade]').forEach(el => {
        const on = fits(el);
        el.classList.toggle('hq2-off', !on);
        if (on && !first && el.hasAttribute('data-hq2-slide')) first = el;
      });

      /* The stage may be parked on a slide that just disappeared. */
      if (first && this.goToMedia) this.goToMedia(first.dataset.hq2Slide);
    }

    /* The line under the stage, shown only while the photographs on screen are
       of a different texture from the one selected. An empty handle hides it,
       so the normal case costs nothing. The label comes from the option values
       themselves rather than from the file-name token — the customer chose
       "Body Wave", not "body-wave". */
    noteTexture(handle) {
      const el = this.querySelector('[data-hq2-tex-note]');
      if (!el) return;
      const tpl = el.dataset.template || '';
      if (!handle || !tpl) { el.hidden = true; return; }
      let label = handle;
      try {
        const map = JSON.parse(this.dataset.hq2TexLabels || '{}');
        if (map[handle]) label = map[handle];
      } catch (e) { /* leave the handle as the label */ }
      el.textContent = tpl.replace('{texture}', label);
      el.hidden = false;
    }

    /* ---- render ---- */
    render() {
      const v = this.currentVariant();
      const fmt = this.moneyCfg.format;

      /* In high-variant mode the chosen values — not a looked-up variant — are
         what the buttons and the gallery follow, because the lookup would be
         against a list that stops at 250. Price, availability and the stock
         line come from the server in mergeRemote() instead. */
      const opts = this.highVariant ? this.selected : v.options;

      // option button states
      this.querySelectorAll('[data-hq2-value]').forEach(btn => {
        const pos = parseInt(btn.dataset.position, 10) - 1;
        btn.setAttribute('aria-pressed', String(opts[pos] === btn.dataset.value));

        /* Per-value availability needs the full variant set to be honest.
           Guessing from a truncated one would strike out most of the palette,
           which is worse than not marking it at all. */
        if (this.highVariant) return;

        const probe = v.options.slice();
        probe[pos] = btn.dataset.value;
        for (let i = pos + 1; i < probe.length; i++) probe[i] = null;
        const any = this.variants.some(x => probe.every((o, i) => o == null || x.options[i] === o) && x.available);
        btn.dataset.unavailable = String(!any);
      });

      this.querySelectorAll('[data-hq2-selected-label]').forEach(el => {
        const raw = opts[parseInt(el.dataset.hq2SelectedLabel, 10) - 1] || '';
        const sw = this.querySelector(`.hq2-sw[data-value="${CSS.escape(raw)}"]`);
        el.textContent = sw?.dataset.label || raw;
      });
      this.renderShade();

      // ruler fill + silhouette
      const fill = this.querySelector('[data-hq2-ruler-fill]');
      if (fill) {
        const ticks = [...this.querySelectorAll('.hq2-tick')];
        const idx = ticks.findIndex(t => t.getAttribute('aria-pressed') === 'true');
        fill.style.width = idx < 0 ? '0%' : `${((idx + 1) / ticks.length) * 100}%`;

        const clip = this.querySelector('[data-hq2-hair-clip]');
        const y = idx < 0 ? 0 : parseFloat(ticks[idx].dataset.y || 0);
        if (clip && y) {
          /* Position is a percentage only. Setting transform as well would
             offset the mark a second time, by y pixels. */
          clip.style.height = y + '%';
          this.querySelector('[data-hq2-fig-mark]').style.top = y + '%';
          this.querySelector('[data-hq2-fig-mark-label]').textContent = ticks[idx].dataset.mark || '';
          const lead = this.querySelector('[data-hq2-len-lead]');
          if (lead) lead.textContent = ticks[idx].dataset.phrase || '';
        }
      }

      /* Length without the ruler: the phrase comes from the hidden list beside
         it, keyed by option value, since there are no ticks to read it from. */
      const lenPlain = this.querySelector('[data-hq2-len-plain]');
      if (lenPlain) {
        const val = opts[parseInt(lenPlain.dataset.position, 10) - 1] || '';
        const node = val
          ? lenPlain.querySelector(`[data-hq2-len-phrases] [data-v="${CSS.escape(val)}"]`)
          : null;
        const lead = lenPlain.querySelector('[data-hq2-len-lead]');
        if (lead) lead.textContent = node ? node.textContent.trim() : '';
      }

      this.syncGallery({ options: opts });

      /* Everything below reads the variant object, so in high-variant mode it
         waits for the server rather than answering from the truncated list. */
      if (!this.highVariant) {
        // price
        const priceEl = this.querySelector('[data-hq2-price]');
        const cmpEl = this.querySelector('[data-hq2-compare]');
        const saveEl = this.querySelector('[data-hq2-save]');
        const badge = this.querySelector('[data-hq2-sale-badge]');
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        /* Kept beside the formatted string for the tier ladder, which
           needs cents rather than a parsed price. */
        if (priceEl) priceEl.dataset.cents = v.price;
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (cmpEl) { cmpEl.hidden = !onSale; cmpEl.textContent = onSale ? money(v.compare_at_price, fmt) : ''; }
        if (saveEl) { saveEl.hidden = !onSale; saveEl.textContent = onSale ? `Save ${money(v.compare_at_price - v.price, fmt)}` : ''; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = `Save ${Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100)}%`;
        }

        // availability
        if (this.atc) {
          this.atc.disabled = !v.available;
          const t = this.atc.querySelector('[data-hq2-atc-text]');
          if (t) t.textContent = v.available ? (t.dataset.on || t.textContent) : (t.dataset.off || t.textContent);
          this.syncAtcPrice(v.available);
        }

        // stock line
        const stock = this.querySelector('[data-hq2-stock]');
        if (stock) {
          const txt = stock.querySelector('[data-hq2-stock-text]');
          const low = parseInt(this.dataset.lowStock, 10) || 0;
          if (!v.available) { stock.dataset.state = 'out'; txt.textContent = 'Out of stock — join the restock list'; }
          else if (v.inventory_management && low > 0 && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
            stock.dataset.state = 'low'; txt.textContent = `Only ${v.inventory_quantity} left in this shade & length`;
          } else { stock.dataset.state = 'ok'; txt.textContent = 'In stock — ready to ship'; }
        }

        this.syncSticky({ meta: v.title, available: v.available, media: v.featured_image || v.featured_media?.preview_image });
        this.syncTierPrices();

        // jump gallery to variant media
        if (v.featured_media && this.goToMedia) {
          const slide = this.querySelector(`[data-media-id="${v.featured_media.id}"]`);
          if (slide && !slide.classList.contains('hq2-off')) this.goToMedia(slide.dataset.hq2Slide);
        }

        // URL
        if (this.dataset.history === 'true' && window.history.replaceState) {
          window.history.replaceState({}, '', `${this.dataset.url}?variant=${v.id}`);
        }
      }
    }

    /* ---- delivery estimate ---- */
    renderEta() {
      const el = this.querySelector('[data-hq2-eta]');
      if (!el) return;
      const min = parseInt(this.dataset.shipMin, 10) || 5;
      const max = parseInt(this.dataset.shipMax, 10) || 15;
      const o = { month: 'short', day: 'numeric' };
      const a = businessDays(new Date(), min).toLocaleDateString('en-US', o);
      const b = businessDays(new Date(), max).toLocaleDateString('en-US', o);
      el.textContent = `${a} – ${b}`;
    }

    /* ---- add to cart ---- */
    /* Resolves as soon as no variant lookup is in flight. The ceiling matters:
       a request that fails or never returns must not leave the button inert
       for good — after it the submit proceeds with whatever the id says, which
       is the same behaviour as before this guard existed. */
    variantSettled(timeout = 8000) {
      return new Promise(resolve => {
        const started = Date.now();
        const poll = setInterval(() => {
          if (!this.classList.contains('hq2-busy') || Date.now() - started > timeout) {
            clearInterval(poll);
            resolve();
          }
        }, 80);
      });
    }

    bindForm() {
      this.form.addEventListener('submit', async e => {
        e.preventDefault();

        /* On a product with more than 250 variants a shade click is answered by
           the server, and on a page carrying this many apps that answer can take
           several seconds. Until it lands the hidden id still names the PREVIOUS
           variant, so a click on Add to cart inside that window put a shade in
           the cart that the customer never chose — silently, with the correct
           one shown on screen. Dimming the button to 55% was not enough: it
           stayed clickable. The submit now waits for the lookup it depends on. */
        if (this.classList.contains('hq2-busy')) {
          this.atc.classList.add('is-busy');
          await this.variantSettled();
          this.atc.classList.remove('is-busy');
        }

        /* In high-variant mode currentVariant() would miss and fall back to
           variants[0]. That is the wrong product in the cart, not a display
           glitch, so the hidden input the server set is the only source of
           truth for the id. */
        const id = this.highVariant
          ? parseInt(this.idInput.value, 10)
          : this.currentVariant().id;
        const soldOut = this.highVariant
          ? this.atc.disabled
          : !this.currentVariant().available;
        if (!id || soldOut) return;

        this.atc.classList.add('is-busy');
        const items = [{ id, quantity: parseInt(this.qtyInput.value, 10) || 1 }];
        /* Every ticked box, not the first one on the page: the kits are offered
           as a list, and a shopper who ticks two of them means both. */
        this.querySelectorAll('[data-hq2-addon], [data-hqpdp-kit]').forEach((box) => {
          if (!box.checked) return;
          const addonId = parseInt(box.dataset.hq2Addon || box.dataset.hqpdpKit, 10);
          if (addonId) items.push({ id: addonId, quantity: 1 });
        });

        /* The count bubble does not refresh on its own. Dawn re-renders it from
           the add response, so the request has to ask for those sections by
           name — without that the item lands in the cart while the icon keeps
           the old number until the next page load. */
        const cartEl = document.querySelector('cart-drawer, cart-notification');
        const sections = cartEl?.getSectionsToRender
          ? cartEl.getSectionsToRender().map(s => s.section || s.id)
          : ['cart-icon-bubble'];

        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
          });
          if (!res.ok) throw new Error('add failed');
          const data = await res.json();

          const mode = this.dataset.afterAdd;
          if (mode === 'cart') { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; return; }
          if (mode === 'checkout') { window.location.href = '/checkout'; return; }

          /* An items-list add returns no top-level key, and the popup finds its
             product row only by that key — without it the render throws. The
             main product is the first item sent, so its line is the one shown. */
          if (data && data.key == null && Array.isArray(data.items) && data.items[0]) {
            data.key = data.items[0].key;
            data.id = data.items[0].id;
          }

          /* Hand the rendered sections to the theme's own cart element when
             there is one — it knows how to swap them and opens itself. If that
             fails AFTER a successful add, go to the cart: the catch below would
             re-submit the form and put the product in the cart a second time. */
          if (cartEl?.renderContents) {
            try {
              cartEl.renderContents(data);
            } catch (renderErr) {
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
              return;
            }
          } else if (data.sections?.['cart-icon-bubble']) {
            /* No drawer on this theme: update just the bubble by hand. */
            const doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            const fresh = doc.querySelector('.shopify-section') || doc.body;
            const target = document.getElementById('cart-icon-bubble');
            if (target && fresh) target.innerHTML = fresh.innerHTML;
          }

          /* Dawn's own subscribers — mini cart, free-shipping bars, upsells. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hq2-pdp', cartData: data });
          }
          document.dispatchEvent(new CustomEvent('hq2:added', { detail: { items } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (err) {
          this.form.submit();
        } finally {
          this.atc.classList.remove('is-busy');
        }
      });
    }

    bindSticky() {
      const bar = this.querySelector('[data-hq2-sticky]');
      if (!bar) return;

      /* Bundle listings have no single variant to submit. Submitting the form
         here would run bindForm(), which adds currentVariant().id — ONE variant
         instead of the set the customer built, silently, with the correct set
         still shown on screen. The builder owns the payload, so the bar
         delegates to it and watches the builder's own button for when to
         appear.

         The guard above drops `|| !this.atc`: on that template the buy_buttons
         block is removed, so this.atc is null and the old guard returned before
         it ever reached the builder. */
      // HQ-MULTIBUY start (PDPJS-1): Sticky bar adds the pack set. Original code kept for rollback:
      // const builder = this.querySelector('hq-bundle-builder');
      // HQ-MULTIBUY new code (PDPJS-1):
      const builder = this.querySelector('hq-bundle-builder, hq-pack-builder');
      // HQ-MULTIBUY end (PDPJS-1)
      if (builder) {
        const trigger = builder.querySelector('[data-add]');
        bar.querySelector('[data-hq2-sticky-atc]')
           .addEventListener('click', () => builder.addToCart());
        if (trigger) {
          new IntersectionObserver(([e]) => {
            bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
          }, { threshold: 0 }).observe(trigger);
        }
        return;
      }

      if (!this.atc) return;
      bar.querySelector('[data-hq2-sticky-atc]').addEventListener('click', () => {
        this.form.requestSubmit ? this.form.requestSubmit() : this.form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      new IntersectionObserver(([e]) => {
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(this.atc);
    }

    /* The bar mirrors the buy column; it never computes anything of its own.

       The price in particular is COPIED from the live price element rather than
       formatted here. Money formatting in JS reads the shop's default currency,
       not the market the customer is actually in, so a second formatter is a
       second answer — and the one on a fixed bar is the one that stays on
       screen. One element formats the price, in Liquid; everything else quotes
       it. Same reason the label is read off the real Add to cart. */
    /* Price on the Add to cart button. Quoted from the price line rather than
       formatted here, for the same reason the sticky bar quotes it: one element
       formats money, in Liquid, and everything else copies that string. */
    /* What the ticked add-on rows come to, in cents. */
    addonCents() {
      let sum = 0;
      this.querySelectorAll('[data-hq2-addon], [data-hqpdp-kit]').forEach((box) => {
        if (!box.checked) return;
        sum += parseInt(box.dataset.hqpdpKitPrice || box.dataset.hq2AddonPrice, 10) || 0;
      });
      return sum;
    }

    /* Formats a sum the way THIS page already writes money.

       Intl's own currency style is not used: in a converted market it prints
       "UAH 9,015.00" where the page's Liquid prints "₴5,634.00", and one
       button showing both spellings reads as a fault. So the number is
       formatted plainly and dressed in the prefix and suffix taken off the
       price Liquid rendered — whatever those happen to be in this market. */
    formatMoney(cents) {
      const sample = (this.querySelector('[data-hq2-price]')?.textContent || '').trim();
      const digits = sample.search(/\d/);
      const prefix = digits > -1 ? sample.slice(0, digits) : '';
      const lastDigit = sample.search(/\d(?!.*\d)/);
      const suffix = lastDigit > -1 ? sample.slice(lastDigit + 1) : '';

      if (!this._number) {
        this._number = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return prefix + this._number.format(cents / 100) + suffix;
    }

    /* The discount percent of the tier currently pressed, or zero when none is.

       Zero is also the honest answer when the shopper has typed a quantity that
       matches no tier: the ladder is an accelerator, not the only way to set a
       number, and quoting a discount for a quantity Kaching will not reward
       would be worse than quoting none. */
    selectedTierOff() {
      const pressed = this.querySelector('[data-hq2-tier][aria-pressed="true"]');
      return pressed ? (parseFloat(pressed.dataset.hq2TierOff) || 0) : 0;
    }

    /* What the ladder is worth, in money, under the ladder itself.

       The percent inside each pill is a rate; this is the reason to take three
       rather than one. On a $195 pack at three the figure is $58.50, which is
       an argument - "-10%" is arithmetic the shopper has to do themselves.

       Quantity comes from the field rather than from the pressed pill, so this
       line and the price on the Add to cart button are always the same sum. A
       quantity matching no tier scores zero off and hides the line: Kaching
       rewards the rungs, not an arbitrary number, and quoting a saving the
       checkout will not honour is worse than quoting none.

       The per-pack figure is the pill's own ROUNDED one, not a second pass at
       the percentage. Rounding after multiplying would put this line a cent or
       two away from what the pills above it add up to, on exactly the odd
       discounts - 12 percent, 15 percent - where someone is most likely to
       check the arithmetic by hand.

       formatTierMoney(), not formatMoney(), for the same reason the pills use
       it: a whole-dollar saving prints as $60 there, and $60.00 here would
       read as a different kind of number sitting directly beneath. */
    syncTierSavings() {
      const el = this.querySelector('[data-hq2-tier-save]');
      if (!el) return;

      const tpl = el.dataset.template || '';
      const base = this.basePriceCents();
      const off = this.selectedTierOff();
      const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);

      if (!tpl || base == null || off <= 0) { el.hidden = true; return; }

      // const saved = (base - Math.round(base * (1 - off / 100))) * qty;
      const saved = (base - Math.round(base * (1 - off / 100) / 100) * 100) * qty;
      if (saved <= 0) { el.hidden = true; return; }

      el.textContent = tpl
        .replace('{amount}', this.formatTierMoney(saved))
        .replace('{count}', qty);
      el.hidden = false;
    }

    syncAtcPrice(available) {
      if (!this.atc) return;
      const sep = this.atc.querySelector('[data-hq2-atc-sep]');
      const price = this.atc.querySelector('[data-hq2-atc-price]');
      if (!price) return;

      /* What the button quotes is what the cart will hold: the quantity times
         the per-pack price of the chosen tier, plus any kit ticked below.

         It used to quote the single-variant price straight from the price line.
         That was fine while the quantity stepper was the only way to order more
         than one and almost nobody touched it. With a tier ladder on the page
         it became the first thing that looked wrong: picking three packs at
         $261 left a button reading $290, which is neither three packs nor the
         undiscounted price of three.

         The per-pack figure is the same one the pill shows, deliberately - one
         calculation feeding both, so the button and the rung the shopper just
         clicked can never disagree. Which also means both carry the same
         dependency: the percentages are display only, and if they drift from
         the Kaching offer the button drifts with them.

         Money is formatted through formatMoney(), which dresses the number in
         the prefix and suffix taken off the price Liquid rendered. Intl's own
         currency style prints a different spelling in a converted market, and
         a button showing one spelling beside a page using another reads as a
         fault. */
      const base = this.basePriceCents();
      if (base != null) {
        const qty = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
        // const unit = Math.round(base * (1 - this.selectedTierOff() / 100));
        const unit = Math.round(base * (1 - this.selectedTierOff() / 100) / 100) * 100;
        // price.textContent = this.formatMoney(unit * qty + this.addonCents());
        price.textContent = this.formatTierMoney(unit * qty + this.addonCents());
      } else {
        /* No figure in cents to work from - a template with the price block
           removed. Quote the Liquid string rather than inventing one. */
        const txt = (this.querySelector('[data-hq2-price]')?.textContent || '').trim();
        if (txt) price.textContent = txt;
      }

      if (available !== undefined) {
        price.hidden = !available;
        if (sep) sep.hidden = !available;
      }
    }

    syncSticky({ meta, available, media } = {}) {
      const bar = this.querySelector('[data-hq2-sticky]');
      if (!bar) return;

      const metaEl = bar.querySelector('[data-hq2-sticky-meta]');
      if (metaEl && meta !== undefined) metaEl.textContent = meta || '';

      const priceTxt = (this.querySelector('[data-hq2-price]')?.textContent || '').trim();
      if (priceTxt) {
        const priceEl = bar.querySelector('[data-hq2-sticky-price]');
        const btnPriceEl = bar.querySelector('[data-hq2-sticky-btn-price]');
        if (priceEl) priceEl.textContent = priceTxt;
        if (btnPriceEl) btnPriceEl.textContent = priceTxt;
      }

      if (available !== undefined) {
        const btn = bar.querySelector('[data-hq2-sticky-atc]');
        if (btn) btn.disabled = !available;
        /* The price reads as a promise next to a Sold out label, so it goes
           with the button's own copy when there is nothing to buy. */
        bar.querySelectorAll('[data-hq2-sticky-btn-price], .hq2-sticky-btn-sep')
          .forEach(el => { el.hidden = !available; });
      }

      const img = bar.querySelector('[data-hq2-sticky-img]');
      if (img && media && media.src) {
        /* Asking the CDN for the thumbnail's own size. Set, not appended: the
           variant URL already carries a width on some products, and two width
           params leave the CDN honouring whichever it reads first. */
        try {
          const u = new URL(media.src, window.location.href);
          u.searchParams.set('width', '160');
          img.src = u.toString();
        } catch (e) { img.src = media.src; }
      }
      // HQ-MULTIBUY start (PDPJS-2): Sticky bar shows the set total. Added
      const packs = this.querySelector('hq-pack-builder');
      if (packs && typeof packs.syncHostChrome === 'function') packs.syncHostChrome();
      // HQ-MULTIBUY end (PDPJS-2)
    }

    /* ---- accordions ----

       Same mechanism as the wig PDP. Opening writes the measured height so the
       transition has something to run to, then releases it to `none` on
       transitionend — a panel left pinned to a number would clip its own
       content the moment anything inside it reflowed (a font swapping in, a
       link wrapping at a new width). Closing does the reverse: the number is
       written first and dropped to zero on the NEXT frame, because a transition
       from `none` has no start value and would snap shut. */
    bindAccordions() {
      this.querySelectorAll('.hq2-acc').forEach(acc => {
        const head = acc.querySelector('.hq2-acc-head');
        const panel = acc.querySelector('.hq2-acc-panel');
        if (!head || !panel) return;

        /* Rows set to start open are opened here rather than with an inline
           style in the markup, which keeps every style in the stylesheet. */
        if (acc.classList.contains('is-open')) panel.style.maxHeight = 'none';

        head.addEventListener('click', () => {
          if (acc.classList.contains('is-open')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
            requestAnimationFrame(() => { panel.style.maxHeight = '0px'; });
            acc.classList.remove('is-open');
            head.setAttribute('aria-expanded', 'false');
          } else {
            acc.classList.add('is-open');
            head.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            panel.addEventListener('transitionend', function te(e) {
              if (e.propertyName === 'max-height' && acc.classList.contains('is-open')) {
                panel.style.maxHeight = 'none';
              }
              panel.removeEventListener('transitionend', te);
            });
          }
        });
      });
    }

    /* ---- photo lightbox ----

       The list of photos is rebuilt every time the lightbox opens rather than
       once at start-up. The gallery is filtered to the selected shade, so the
       set of slides on screen changes with the palette — a list captured at
       start-up would page through photographs of shades the customer is not
       looking at. */
    bindZoom() {
      const lb = this.querySelector('[data-hq2-lb]');
      const btn = this.querySelector('[data-hq2-zoom]');
      if (!lb) return;

      const img = lb.querySelector('[data-hq2-lb-img]');
      const dots = lb.querySelector('[data-hq2-lb-dots]');
      const prev = lb.querySelector('[data-hq2-lb-prev]');
      const next = lb.querySelector('[data-hq2-lb-next]');
      const close = lb.querySelector('[data-hq2-lb-close]');

      let shots = [];
      let current = 0;

      const visibleShots = () => [...this.querySelectorAll('[data-hq2-slide]')]
        .filter(s => !s.classList.contains('hq2-off'))
        .map(s => s.querySelector('[data-hq2-zoom-src]'))
        .filter(Boolean);

      const showAt = (i) => {
        if (!shots.length) return;
        current = (i + shots.length) % shots.length;
        const src = shots[current];
        img.src = src.getAttribute('data-hq2-zoom-src');
        img.alt = src.getAttribute('alt') || '';
        [...dots.children].forEach((d, di) => d.classList.toggle('is-active', di === current));
        const single = shots.length < 2;
        prev.hidden = single;
        next.hidden = single;
        dots.hidden = single;
      };

      const open = (i) => {
        shots = visibleShots();
        if (!shots.length) return;

        dots.innerHTML = '';
        shots.forEach((_, di) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 'hq2-lb-dot';
          d.setAttribute('aria-label', `Go to image ${di + 1}`);
          d.addEventListener('click', () => showAt(di));
          dots.appendChild(d);
        });

        showAt(i);
        lb.showModal();
        window.hqScrollLock.lock();
        requestAnimationFrame(() => lb.classList.add('is-open'));
      };

      const shut = () => {
        lb.classList.remove('is-open');
        window.hqScrollLock.unlock();
        setTimeout(() => { if (lb.open) lb.close(); img.src = ''; }, 300);
      };

      /* Which photo is on screen right now. The slides are a scroller, so the
         one nearest the middle of the viewport is the one being looked at. */
      const currentSlideIndex = () => {
        const list = visibleShots();
        const box = this.querySelector('[data-hq2-slides]');
        if (!box || !list.length) return 0;
        const mid = box.scrollLeft + box.clientWidth / 2;
        let best = 0;
        let bestGap = Infinity;
        list.forEach((el, i) => {
          const slide = el.closest('[data-hq2-slide]');
          if (!slide) return;
          const gap = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      };

      if (btn) btn.addEventListener('click', () => open(currentSlideIndex()));
      /* Tapping the photograph opens it too — the expected gesture on a phone,
         where the pill is small and sits in a corner. */
      this.querySelectorAll('[data-hq2-zoom-src]').forEach(el => {
        el.addEventListener('click', () => open(currentSlideIndex()));
      });

      prev.addEventListener('click', () => showAt(current - 1));
      next.addEventListener('click', () => showAt(current + 1));
      close.addEventListener('click', shut);

      /* Swipe between photos. On a phone the arrows are hidden (CSS), so this
         is how the viewer pages there; horizontal moves only, so a vertical
         drag never flips the photo. */
      let sx = 0;
      let sy = 0;
      /* No scroll chaining out of the viewer: a drag on the photo must not
         move the page behind it. */
      lb.addEventListener('touchmove', (e) => { if (e.cancelable) e.preventDefault(); }, { passive: false });
      lb.addEventListener('touchstart', (e) => {
        const t0 = e.changedTouches[0];
        sx = t0.clientX;
        sy = t0.clientY;
      }, { passive: true });
      lb.addEventListener('touchend', (e) => {
        if (shots.length < 2) return;
        const t1 = e.changedTouches[0];
        const dx = t1.clientX - sx;
        const dy = t1.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        showAt(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      /* Clicking the surround closes; clicking the photo does not. */
      lb.addEventListener('click', (e) => {
        if (e.target === lb || e.target.classList.contains('hq2-lb-inner') || e.target.classList.contains('hq2-lb-stage')) shut();
      });
      /* Esc is handled by the dialog itself — this keeps the fade and the
         scroll release running rather than letting it vanish. */
      lb.addEventListener('cancel', (e) => { e.preventDefault(); shut(); });
      lb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') showAt(current - 1);
        else if (e.key === 'ArrowRight') showAt(current + 1);
      });
    }

    /* ---- UGC rail + viewer ---- */
    bindUGC() {
      this.cards = [...this.querySelectorAll('[data-hq2-ugc]')];
      if (!this.cards.length) return;
      this.viewer = this.querySelector('[data-hq2-viewer]');
      this.vVideo = this.querySelector('[data-hq2-viewer-video]');
      this.vBars = this.querySelector('[data-hq2-viewer-bars]');
      this.vCta = this.querySelector('[data-hq2-viewer-cta]');

      this.vBars.innerHTML = this.cards.map(() => '<span class="hq2-viewer-bar"><i></i></span>').join('');

      this.cards.forEach(c => c.addEventListener('click', () => this.openUGC(parseInt(c.dataset.hq2Ugc, 10))));
      this.querySelector('[data-hq2-viewer-close]').addEventListener('click', () => this.closeUGC());
      this.querySelector('[data-hq2-viewer-prev]').addEventListener('click', () => this.openUGC(this.ugcIndex - 1));
      this.querySelector('[data-hq2-viewer-next]').addEventListener('click', () => this.openUGC(this.ugcIndex + 1));
      this.vVideo.addEventListener('ended', () => this.openUGC(this.ugcIndex + 1));
      this.viewer.addEventListener('close', () => { this.vVideo.pause(); this.vVideo.removeAttribute('src'); });
      this.viewer.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') this.openUGC(this.ugcIndex + 1);
        if (e.key === 'ArrowLeft') this.openUGC(this.ugcIndex - 1);
      });
    }

    openUGC(i) {
      if (i < 0) i = 0;
      if (i > this.cards.length - 1) return this.closeUGC();
      this.ugcIndex = i;
      const c = this.cards[i];

      if (!this.viewer.open) this.viewer.showModal();
      this.vVideo.poster = c.dataset.poster || '';
      this.vVideo.src = c.dataset.src || '';
      this.vVideo.muted = false;
      this.vVideo.play().catch(() => { this.vVideo.muted = true; this.vVideo.play().catch(() => {}); });

      [...this.vBars.children].forEach((b, j) => b.setAttribute('data-seen', String(j <= i)));

      if (c.dataset.pUrl) {
        this.vCta.hidden = false;
        this.vCta.href = c.dataset.pUrl;
        this.querySelector('[data-hq2-viewer-cta-img]').src = c.dataset.pImg || '';
        this.querySelector('[data-hq2-viewer-cta-title]').textContent = c.dataset.pTitle || '';
        this.querySelector('[data-hq2-viewer-cta-price]').textContent = c.dataset.pPrice || '';
      } else {
        this.vCta.hidden = true;
      }
    }

    closeUGC() { if (this.viewer.open) this.viewer.close(); }
  }

  /* Add-on kit rows. Delegated from the document rather than bound per row, so
     a section re-render in the theme editor cannot leave dead listeners behind.

     The contents toggle is a BUTTON inside the row's <label>: a click on it
     would tick the box as well as open the list, so the panel toggle answers
     the click and the product link stops it before it reaches the label. */
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('[data-hqpdp-kit-link]');
    if (link) { e.stopPropagation(); return; }

    const btn = e.target.closest && e.target.closest('[data-hqpdp-kit-toggle]');
    if (!btn || !btn.closest('[data-hqpdp-kits]')) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
    const row = btn.closest('.hqpdp__kit');
    if (row) row.classList.toggle('is-open', !open);
  });

  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('[data-hq2-addon], [data-hqpdp-kit]')) return;
    const row = e.target.closest('.hqpdp__kit');
    if (row) row.classList.toggle('is-checked', e.target.checked);
    /* The button quotes what will be charged, so it has to answer the tick. */
    const pdp = e.target.closest('hq2-pdp');
    if (pdp && typeof pdp.syncAtcPrice === 'function') pdp.syncAtcPrice();
  });

  customElements.define('hq2-pdp', HQ2PDP);
})();